import React, { useState } from "react";

import { Row, Col, FormGroup, Button, Label } from "reactstrap";

import ControldocDataTable from "../../../../controldoc/datatable";

const BulkRequestDestroyEmployeeTable = props => {
  const {
    bulkRequest,
    setBulkRequest,
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      formName,
    },
    routes: {
      indexEmployeesPath,
      indexBulkRequestPath,
      showBulkRequestPath,
    },
    services: {
      createService,
    }
  } = props;

  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false);

  const onSelectionChange = selectedRecords => {
    setBulkRequest(prevState => {
      return {
        ...prevState,
        ['employees']: selectedRecords
      }
    })
  }

  const handleConfirmSubmit = () => {
    swalWithBootstrap
      .fire({
        title: I18n.t(
          "laboral.bulk.request.destroy_employees.form.confirm.title"
        ),
        html: I18n.t(
          "laboral.bulk.request.destroy_employees.form.confirm.message"
        ),
      })
      .then(result => {
        if (result.isConfirmed) {
          handleSubmit();
        }
      });
  };

  const drawTextSubmitButton = () => {
    if (disabledSubmitButton) {
      return "Guardando información ...";
    } else {
      return I18n.t("actions.save");
    }
  };

  const drawSubmitButton = () => {
    return (
      <Button
        color="success"
        className="ml-2"
        onClick={handleConfirmSubmit}
        disabled={disabledSubmitButton}
      >
        {drawTextSubmitButton()}
      </Button>
    );
  };

  const handleSubmit = () => {
    let formData = getFormData();
    setDisabledSubmitButton(true);

    createService(formData, response => {
      if (response.status == 201) {
        window.location = showBulkRequestPath(response.data.id);
      } else if (response.status == 422) {
        setBulkRequest(response.data);
        setDisabledSubmitButton(false);
      }
    });
  };

  const getFormData = () => {
    let _formData = new FormData();
    if (_.some(bulkRequest.employees)) {
      _.each(bulkRequest.employees, function (item, index) {
        _formData.append(`${formName}[employee_ids][]`, item.id)
      })
    } else {
      _formData.append(`${formName}[employee_ids][]`, '')
    }

    return _formData;
  }

  const drawItemsErrors = () => {
    if (_.has(bulkRequest, 'errors.items')) {
      return (
        <div className="alert alert-danger">
          {_.map(bulkRequest.errors.items, function (error, index) {
            return <span key={`item-error-${index}`}>{error}</span>
          })}
        </div>
      )
    }
  }

  return (
    <Row>
      <Col md={12}>
        <Label className="d-flex justify-content-center h5 my-4">Lista de trabajadores</Label>
        {drawItemsErrors()}
        <ControldocDataTable
          columns={dataTableColumns}
          configuration={{
            showDistributionListFilter: false,
            showGridlines: true,
            context: 'laboral',
            fetchRecords: {
              endpoint: indexEmployeesPath,
              keyName: "employees",
              defaultRequestParams: {}
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: bulkRequest['employees'],
              onSelectionChange: onSelectionChange
            }
          }}
        />
      </Col>
      <FormGroup className="text-end mt-5">
        <a
          href={indexBulkRequestPath()}
          className="btn btn-default"
        >
          {I18n.t("actions.back")}
        </a>
        {drawSubmitButton()}
      </FormGroup>
    </Row>
  )
}

export default BulkRequestDestroyEmployeeTable;
